const frameQueue = [];
let rafScheduled = false;
const rafCallback = (time) => {
    let c;
    do {
        c = frameQueue.shift();
        if (c) {
            c(time);
        }
    } while (performance.now() - time < 10 && frameQueue.length > 0);
    // TO-DO in Firefox perf.now() can have reduced precision.
    // Is it still useable for this case? => https://developer.mozilla.org/en-US/docs/Web/API/Performance/now
    if (frameQueue.length > 0) {
        // if there was not enough time to execute all callbacks, a new requestAnimationFrame will be scheduled
        window.requestAnimationFrame(rafCallback);
    }
    else {
        rafScheduled = false;
    }
};
/**
 * nextFrame acts as a wrapper for window#requestAnimationFrame,
 * but queues requests and executes every Frame until the 10ms time Budget is over
 *
 * based on https://caniuse.com/#feat=requestanimationframe no polyfill is required.
 * Further details on raf: https://medium.com/@paul_irish/requestanimationframe-scheduling-for-nerds-9c57f7438ef4
 */
export const nextFrame = (callback) => {
    frameQueue.push(callback);
    if (!rafScheduled) {
        rafScheduled = true;
        window.requestAnimationFrame(rafCallback);
    }
};
/**
 * based on https://caniuse.com/#feat=requestidlecallback a polyfill is required to support most of the modern browsers
 */
export const nextTick = (callback, opts) => {
    window.requestIdleCallback(callback, opts);
};
const reqIdlePolyfill = (cb) => {
    const start = Date.now();
    return window.setTimeout(() => {
        cb({
            didTimeout: false,
            timeRemaining: () => {
                return Math.max(0, 50 - (Date.now() - start));
            }
        });
    }, 1);
};
const cancelIdlePolyfill = (handle) => {
    clearTimeout(handle);
};
// apply polyfill if needed
window.requestIdleCallback = window.requestIdleCallback || reqIdlePolyfill;
window.cancelIdleCallback = window.cancelIdleCallback || cancelIdlePolyfill;
//# sourceMappingURL=Runtime.js.map